import { z } from "zod";

const BookingResponseDataSchema = z.object({
    booking_id: z.string().uuid(),
    source: z.string(),
    property_name: z.string(),
    invoice_number: z.string(),
    // voucher_number bisa NULL untuk booking direct/non-OTA (bukan dari Channex),
    // jadi WAJIB nullable agar safeParse tidak gagal untuk seluruh Sales Report
    voucher_number: z.string().nullable(),
    invoice_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(), // Ensures YYYY-MM-DD format
    // Keduanya diambil lewat LEFT JOIN di backend (room_types & rooms), dan
    // booking_rooms.room_type_id / room_id sama-sama nullable — booking yang
    // belum di-assign kamar (unassigned) mengembalikan room_number NULL.
    //
    // WAJIB nullable: hook memakai safeParse yang melempar error saat gagal,
    // jadi SATU baris dengan kamar belum ter-assign membuat SELURUH Sales Report
    // kosong, bukan cuma baris itu. Ini persis bug yang dilaporkan QA
    // ("room type tertentu dicentang -> tidak muncul data sama sekali").
    room_type_name: z.string().nullable(),
    room_number: z.string().nullable(),
    customer_name: z.string(),
    customer_surname: z.nullable(z.string()),
    customer_email: z.nullable(z.string()),
    customer_phone: z.string().nullable(),
    customer_country: z.string().nullable(),
    checkin_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // Ensures YYYY-MM-DD format
    checkout_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    // `night` = DATEDIFF(checkout, checkin) di backend, jadi booking day-use
    // (checkin sama dengan checkout) bernilai 0. `.positive()` menolak 0 dan
    // ikut mengosongkan seluruh report, jadi cukup `.int()`.
    night: z.number().int(),
    rates: z.string().regex(/^\d+(\.\d{1,2})?$/) // Ensures a number with up to 2 decimal places
});

const BookingResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(BookingResponseDataSchema),
    total: z.coerce.number(),
});

export { BookingResponseDataSchema, BookingResponseSchema };

export type BookingResponseData = z.infer<typeof BookingResponseDataSchema>;
export type BookingResponse = z.infer<typeof BookingResponseSchema>;